import React, { useContext, useMemo } from "react"

import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductConfiguratorProps } from "../ProductConfigurator"

export interface ProductConfiguratorProductInfoContextType {
  productTitle?: string
  productImage?: React.ReactNode
  productInformation?: ProductInformation | null | undefined
  isLoadingProductInformation?: boolean
}

export const DEFAULT_PRODUCT_CONFIGURATOR_PRODUCT_INFO_CONTEXT: ProductConfiguratorProductInfoContextType =
  {}

export const ProductConfiguratorProductInfoContext =
  React.createContext<ProductConfiguratorProductInfoContextType>(
    DEFAULT_PRODUCT_CONFIGURATOR_PRODUCT_INFO_CONTEXT
  )

export function useProductConfiguratorProductInfoContext(): ProductConfiguratorProductInfoContextType {
  return useContext(ProductConfiguratorProductInfoContext)
}

export function useProductConfiguratorProductInfoContextValue(
  model: ProductConfiguratorProps
): ProductConfiguratorProductInfoContextType {
  const {
    productTitle,
    productImage,
    productInformation,
    isLoadingProductInformation
  } = model

  return useMemo<ProductConfiguratorProductInfoContextType>(
    () => ({
      productTitle,
      productImage,
      productInformation,
      isLoadingProductInformation
    }),
    [
      productTitle,
      productImage,
      productInformation,
      isLoadingProductInformation
    ]
  )
}

export function ProductConfiguratorProductInfoContextProvider({
  children,
  model
}: {
  children: React.ReactNode
  model: ProductConfiguratorProps
}) {
  const value = useProductConfiguratorProductInfoContextValue(model)

  return (
    <ProductConfiguratorProductInfoContext.Provider value={value}>
      {children}
    </ProductConfiguratorProductInfoContext.Provider>
  )
}
